import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { DrawerObject } from '@/components/drawer/drawer.types';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';
import { Snippet } from '@/types/meeting.types';

interface IGetExtraitsPvMeetingDrawerProps {
  store: MeetingRepository;
  data: any[];
  totalRecords: number;
  rowActionsFn: (...args: any[]) => DataTableRowActions;
  serverQuery?: DataTableServerQuery;
  comType: string;
}

interface IGetSnippetsDataTableStructureProps {
  rowActionsFn: (...args: any[]) => DataTableRowActions;
  store: MeetingRepository;
  comType: string;
}

export const getSnippetsDataTableStructure = ({ rowActionsFn, store, comType }: IGetSnippetsDataTableStructureProps): DynamicDataTable => {
  const extraitsIdColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.snippets.table.id',
    accessorKey: 'extraitId',
    variant: DataTableColumnVariant.TEXT,
  };

  const snippetTypeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.snippets.table.type.label',
    accessorKey: 'extraitType',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: `meeting.snippets.table.type.${value}`,
      };
    },
  };

  const dossierRefColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.snippets.table.ref',
    accessorKey: 'dossier.ref',
    variant: DataTableColumnVariant.TEXT,
  };

  const dossierTypeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.snippets.table.dossierType',
    accessorKey: 'type',
    variant: DataTableColumnVariant.TEXT,
  };

  const acNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.snippets.table.ac',
    accessorKey: 'ac.nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const statusColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.snippets.table.status',
    accessorKey: 'doc',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string, row: any) => {
      return { value: row.doc ? 'Signé' : 'Non Signé' };
    },
  };

  const columns: DynamicDataTableColumn<DataTableColumnTextProps>[] = [extraitsIdColumn, acNameColumn];

  if (comType !== 'CPMP') {
    columns.push(dossierTypeColumn);
    columns.push(dossierRefColumn);
  }

  columns.push(snippetTypeColumn, statusColumn);

  return {
    singular: 'meeting.snippets.table.singular',
    plural: 'meeting.snippets.table.plural',
    columns: columns,
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    searchableFields: ['id', 'ac.nom'],
    target: (row: Snippet) => {
      store.set('downloadSnippetDto', {
        extraitId: row.extraitId,
        acId: row.ac.id,
        extraitType: row.extraitType,
        dossier: row.dossier,
        type: row.type,
      });
      store.set('uploadSnippetDto', {
        extraitId: row.extraitId,
        acId: row.ac.id,
        extraitType: row.extraitType,
      });
    },
    rowActionsFn,
    rowRenderOverride: (row: any) => {
      return {
        class: row.doc ? 'bg-green-100 dark:bg-green-900' : '',
      };
    },
  };
};

export const getExtraitsPvMeetingDrawer = ({ data, totalRecords, rowActionsFn, store, comType }: IGetExtraitsPvMeetingDrawerProps): DrawerObject => {
  return {
    title: 'meeting.snippets.title',
    description: '',
    width: '75vw',

    component: {
      outlet: DataTableBuilderComponent,
      props: {
        dataTableObject: getSnippetsDataTableStructure({ rowActionsFn, store, comType }),
        datas: data,
        totalRecords: totalRecords,
      },
    },
  };
};
